module.exports = __webpack_public_path__ + "img/Elements_Icons_Analyst Access.28d608af.png";